import { LitElement, html } from "lit-element";

export class SecondaryToolbarSeparator extends LitElement {
	render() {
		return html`
            <style>
                :host {
                    width: 100%;
                    height: 0px;
                }
            </style>
        `;
	}
}

window.customElements.define("inspx-draw-tb-separator", SecondaryToolbarSeparator);